import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  timeout: 15000,
});

export function errMsg(e, fallback = "Xəta baş verdi. Zəhmət olmasa yenidən cəhd edin.") {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "Serverlə əlaqə yoxdur. İnternet bağlantınızı yoxlayıb yenidən cəhd edin.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ") || fallback;
  return fallback;
}

export const fmt = (n) => Number(n || 0).toLocaleString("ru-RU").replace(/,/g, " ");

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("az-AZ", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—";

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("az-AZ", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
